<template>
  <div class="comment-page">
    <van-nav-bar fixed title="订单评价" left-text="返回" left-arrow @click-left="goBack" />

    <template v-if="order">
      <div class="comment-body">
        <!-- 订单信息 -->
        <div class="order-info">
          <span>订单号：{{ order.order_no }}</span>
          <span class="oi-status">{{ order.state_text }}</span>
        </div>

        <!-- 商品评价列表 -->
        <div class="goods-card">
          <div class="goods-rate-item" v-for="g in order.goods" :key="g.goods_id">
            <div class="gr-head">
              <img :src="g.goods_image" alt="" />
              <div class="gr-right">
                <div class="gr-name text-ellipsis-2">{{ g.goods_name }}</div>
                <div class="gr-price">¥{{ g.goods_price }} × {{ g.total_num }}</div>
              </div>
            </div>
            <div class="gr-rate">
              <span class="gr-rate-label">商品评分</span>
              <van-rate v-model="rateMap[g.goods_id]" size="22" />
            </div>
            <textarea
              class="reason-input"
              v-model.trim="commentMap[g.goods_id]"
              rows="2"
              maxlength="200"
              placeholder="说说您对这件商品的感受吧（必填）"
            ></textarea>
          </div>
        </div>

        <button class="submit-btn" :disabled="submitting" @click="submit">提交评价</button>
      </div>
    </template>

    <!-- 无订单数据（直接访问或刷新后数据丢失） -->
    <div v-else class="empty-state">
      <van-icon name="comment-o" size="60" color="#ccc" />
      <p>未找到待评价的订单</p>
      <van-button type="primary" round @click="$router.replace('/myorder')">去我的订单</van-button>
    </div>

    <div class="bottom-placeholder"></div>
  </div>
</template>

<script>
import { commentOrderApi } from '@/api/order'
import { Toast } from 'vant'
import { readOrder } from '@/utils/orderTransfer'

export default {
  name: 'OrderComment',
  data () {
    return {
      order: null,
      rateMap: {},
      commentMap: {},
      submitting: false
    }
  },
  created () {
    this.order = readOrder()
    if (this.order) {
      const rateMap = {}
      const commentMap = {}
      this.order.goods.forEach(g => {
        rateMap[g.goods_id] = 5
        commentMap[g.goods_id] = ''
      })
      this.rateMap = rateMap
      this.commentMap = commentMap
    }
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/myorder')
      }
    },
    // 提交评价
    async submit () {
      const order = this.order
      if (!order) return
      for (const g of order.goods) {
        if (!(this.commentMap[g.goods_id] || '').trim()) {
          Toast(`请填写「${g.goods_name}」的评价内容`)
          return
        }
      }
      this.submitting = true
      try {
        await Promise.all(order.goods.map(g =>
          commentOrderApi({
            order_id: order.order_id,
            goods_id: g.goods_id,
            score: this.rateMap[g.goods_id] || 5,
            content: (this.commentMap[g.goods_id] || '').trim()
          })
        ))
        Toast.success('评价成功')
        this.$router.replace('/myorder?dataType=comment')
      } catch (err) {
        Toast(typeof err === 'string' ? err : '评价提交失败，请重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.comment-page {
  min-height: 100vh;
  background: #fafafa;
  padding-top: 46px; // 给固定导航栏留空间

  /deep/ .van-nav-bar__arrow { color: #333; }
  /deep/ .van-nav-bar__text { color: #333; }
  /deep/ .van-nav-bar { z-index: 100; }

  .comment-body {
    padding: 12px;

    .order-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: #666;
      padding: 0 2px 10px;

      .oi-status {
        color: #ff6b35;
      }
    }

    // 商品评价卡片
    .goods-card {
      background: #fff;
      border-radius: 8px;
      padding: 0 14px;
      box-shadow: 0 0.5px 2px 0 rgba(0, 0, 0, 0.05);

      .goods-rate-item {
        padding: 14px 0;
        border-bottom: 1px solid #f5f5f5;

        &:last-child {
          border-bottom: none;
        }

        .gr-head {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          img {
            width: 48px;
            height: 48px;
            border-radius: 6px;
            object-fit: cover;
            flex-shrink: 0;
            margin-right: 10px;
          }

          .gr-right {
            flex: 1;
            min-width: 0;

            .gr-name {
              font-size: 14px;
              color: #333;
              line-height: 18px;
            }

            .gr-price {
              font-size: 12px;
              color: #999;
              margin-top: 4px;
            }
          }
        }

        .gr-rate {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          .gr-rate-label {
            font-size: 13px;
            color: #666;
            margin-right: 10px;
          }
        }

        .reason-input {
          width: 100%;
          box-sizing: border-box;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          padding: 10px;
          font-size: 14px;
          font-family: inherit;
          resize: none;
          background: #fafafa;
          outline: none;
        }
      }
    }

    .submit-btn {
      width: 100%;
      height: 44px;
      border: none;
      border-radius: 22px;
      background: linear-gradient(90deg, #ff6b35, #ff8c42);
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      margin-top: 16px;

      &:disabled {
        opacity: 0.6;
      }
    }
  }

  // 无订单数据的空状态
  .empty-state {
    text-align: center;
    padding: 120px 20px;

    p {
      color: #999;
      margin: 12px 0 20px;
    }
  }

  .bottom-placeholder {
    height: 20px;
  }
}
</style>
